'use client'

import { useState } from 'react'
import { MdKeyboardArrowDown } from "react-icons/md"

export default function InvoiceForm() {
  const [formData, setFormData] = useState({
    customer: 'Farukh Zaman',
    applicationNo: 'NV23983',
    paymentType: 'Immediate',
    paymentReceived: 'No',
    invoiceDate: '06/01/25',
    dueDate: '07/01/25',
    assignedAgent: 'Wasim Khalid'
  })

  const handleSubmit = (e) => {
    e.preventDefault()
    // Handle invoice generation
    // console.log('Generating invoice with data:', formData)
  }

  return (
    <div className="bg-[#FFFBF5] border border-[#CAC3BB] p-6">
      <form onSubmit={handleSubmit} className="space-y-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* Left Column */}
          <div className="space-y-4">
            <div className="space-y-2">
              <label className="block text-sm font-medium text-gray-700">
                Customer
              </label>
              <input
                type="text"
                value={formData.customer}
                readOnly
                className="w-full p-2.5 bg-white border border-gray-200 rounded-md text-gray-900 focus:ring-2 focus:ring-blue-500"
              />
            </div>

            <div className="space-y-2">
              <label className="block text-sm font-medium text-gray-700">
                Application No.
              </label>
              <input
                type="text"
                value={formData.applicationNo}
                readOnly
                className="w-full p-2.5 bg-white border border-gray-200 rounded-md text-gray-900 focus:ring-2 focus:ring-blue-500"
              />
            </div>

            <div className="space-y-2">
              <label className="block text-sm font-medium text-gray-700">
                Payment Type
              </label>
              <div className="relative">
                <input
                  type="text"
                  value={formData.paymentType}
                  readOnly
                  className="w-full p-2.5 bg-white border border-gray-200 rounded-md text-gray-900 focus:ring-2 focus:ring-blue-500 pr-10"
                />
                <MdKeyboardArrowDown className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 w-5 h-5" />
              </div>
            </div>

            <div className="space-y-2">
              <label className="block text-sm font-medium text-gray-700">
                Payment Received
              </label>
              <div className="relative">
                <input
                  type="text"
                  value={formData.paymentReceived}
                  readOnly
                  className="w-full p-2.5 bg-white border border-gray-200 rounded-md text-gray-900 focus:ring-2 focus:ring-blue-500 pr-10"
                />
                <MdKeyboardArrowDown className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 w-5 h-5" />
              </div>
            </div>
          </div>

          {/* Right Column */}
          <div className="space-y-4">
            <div className="space-y-2">
              <label className="block text-sm font-medium text-gray-700">
                Invoice Date
              </label>
              <input
                type="text"
                value={formData.invoiceDate}
                readOnly
                className="w-full p-2.5 bg-white border border-gray-200 rounded-md text-gray-900 focus:ring-2 focus:ring-blue-500"
              />
            </div>

            <div className="space-y-2">
              <label className="block text-sm font-medium text-gray-700">
                Due Date
              </label>
              <input
                type="text"
                value={formData.dueDate}
                readOnly
                className="w-full p-2.5 bg-white border border-gray-200 rounded-md text-gray-900 focus:ring-2 focus:ring-blue-500"
              />
            </div>

            <div className="space-y-2">
              <label className="block text-sm font-medium text-gray-700">
                Assigned Agent
              </label>
              <input
                type="text"
                value={formData.assignedAgent}
                readOnly
                className="w-full p-2.5 bg-white border border-gray-200 rounded-md text-gray-900 focus:ring-2 focus:ring-blue-500"
              />
            </div>
          </div>
        </div>

        <div className="flex justify-end">
          <button
            type="submit"
            className="px-6 py-1.5 bg-[#2A3D66] text-white rounded-full hover:bg-[#1e40af] transition-colors duration-200"
          >
            Generate Invoice
          </button>
        </div>
      </form>
    </div>
  )
}

